import { ComponentProps, forwardRef } from 'react';
import { Link } from 'react-router-dom';

import { useInstanceId } from '@frontend/hooks';

type LinkProps = ComponentProps<typeof Link>;

export const NamespacedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  function NamespacedLink(props, ref) {
    const { instanceId } = useInstanceId();
    const { to, ...rest } = props;
    const namespacedTo =
      typeof to === 'string' && to.startsWith('/') && !to.startsWith(`/instances/${instanceId}`)
        ? `/instances/${instanceId}${to}`
        : to;

    return <Link ref={ref} to={namespacedTo} {...rest} />;
  }
);
